import React, { useState } from "react"

import { sanitizeTextForAnalytics } from "@/utils/helper"

import CONSTANTS from "@/constants"
import { NumericFormat } from "react-number-format"
const Loader = props => {
  const {
    pdpData: productInfo,
    skuId,
    pdpJson,
    initialImgAlt,
    initialImgUrl,
  } = props
  const {
    RegionBrandName_s: pdpBrnadName = "",
    ProductDescriptionProductShort_s: pdpShotDesc = "",
    masterCustomerFacingSKU_s: productID = "",
    ProductLocalCategory_s: productCategory = "",
    masterSKU_s: masterSku = "",
    "priceList.ANY.finalPrice_d": anyFinalPrice = "",
    "priceList.GST.finalPrice_d": gstFinalPrice = "",
  } = productInfo
  const { pdpDesktopImage } = pdpJson
  const [initImage] = useState(
    pdpDesktopImage && initialImgUrl
      ? pdpDesktopImage.replace("/}", `/${initialImgUrl}}`)
      : ""
  )
  const [initImageAlt] = useState(initialImgAlt)

  const categoryTmp = sanitizeTextForAnalytics(productCategory)
  const category = categoryTmp
    ?.split(" ")
    .map(a => a.charAt(0).toUpperCase() + a?.slice(1))
    .join(" ")

  const isProductPriceSpiderIncluded = productInfo?.ProductPriceSpiderIncluded_s

  return (
    <div
      className="product-detail-page min-vh-100"
      data-testid={"product-detail-page"}
    >
      <div className="container">
        <div className="header-section  kf-react-plp-container">
          <div className="product-detail-page__breadcrumb">
            <nav aria-label="Breadcrumb">
              <ol role="list">
                <li role="listitem">{" Home / "}</li>
                <li role="listitem">{category ? category : "Parts"}</li>
                <li role="listitem" className="adaopacity">
                  {" "}
                  {" / "}
                  {category ? pdpBrnadName : "Parts"}
                </li>
              </ol>
            </nav>
          </div>
          <div className="product-detail-page__print-share-container">
            <div role="list" className="print-and-share">
              <span role="listitem">
                <button
                  tabIndex="0"
                  className="gbh-data-layer"
                  data-gbh-data-layer=""
                  data-gbh-data-layer-custom=""
                  aria-label="Click here to print "
                >
                  <img
                    src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTdweCIgaGVpZ2h0PSIxN3B4IiB2aWV3Qm94PSIwIDAgMTcgMTciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+UHJpbnQtSWNvbjwvdGl0bGU+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iUHJpbnQiIGZpbGw9IiM3NTc1NzUiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNCwwIEwxNCw0IEwxNyw0IEwxNywxMiBMMTQsMTIgTDE0LDE3IEwzLDE3IEwzLDEyIEwwLDEyIEwwLDQgTDMsNCBMMywwIEwxNCwwIFogTTEzLDEyIEw0LDEyIEw0LDE2IEwxMywxNiBMMTMsMTIgWiBNMyw1IEwxLDUgTDEsMTEgTDE2LDExIEwxNiw1IEwxNCw1IEwxNCw4IEwzLDggTDMsNSBaIE0xMywxIEw0LDEgTDQsNyBMMTMsNyBMMTMsMSBaIiBpZD0iUHJpbnQtSWNvbiI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
                    alt=""
                    role="presentation"
                    width="20"
                    height="20"
                  />
                </button>
              </span>
              <span role="listitem">
                <button
                  tabIndex="0"
                  aria-label="Click here to share "
                  className="share-button"
                >
                  <img
                    src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxN3B4IiB2aWV3Qm94PSIwIDAgMTQgMTciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+c2hhcmU8L3RpdGxlPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9InNoYXJlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMC42MjAzNzIpIiBmaWxsPSIjNzU3NTc1IiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8cGF0aCBkPSJNMy41LDYuODc5NjI4MyBMMy41LDcuODc5NjI4MyBMMSw3Ljg3OTYyODMgTDEsMTQuODc5NjI4MyBMMTMsMTQuODc5NjI4MyBMMTMsNy44Nzk2MjgzIEwxMC41LDcuODc5NjI4MyBMMTAuNSw2Ljg3OTYyODMgTDE0LDYuODc5NjI4MyBMMTQsMTUuODc5NjI4MyBMMCwxNS44Nzk2MjgzIEwwLDYuODc5NjI4MyBMMy41LDYuODc5NjI4MyBaIE03LC04Ljg4MTc4NDJlLTE2IEw3LjQ0MiwwLjM3OSBMNy41LDAuMzc5NjI4MzAxIEw3LjUsMC40MjgwMDAwMDEgTDEwLjgyNTM5NTcsMy4yNzg5MTA1OSBMMTAuMTc0NjA0Myw0LjAzODE2NzE5IEw3LjUsMS43NDYgTDcuNSwxMS4zNzk2MjgzIEw2LjUsMTEuMzc5NjI4MyBMNi41LDEuNzQ2IEwzLjgyNTM5NTY5LDQuMDM4MTY3MTkgTDMuMTc0NjA0MzEsMy4yNzg5MTA1OSBMNi41LDAuNDI4MDAwMDAxIEw2LjUsMC4zNzk2MjgzMDEgTDYuNTU4LDAuMzc5IEw3LC04Ljg4MTc4NDJlLTE2IFoiIGlkPSJDb21iaW5lZC1TaGFwZSI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
                    alt=""
                    role="presentation"
                    width="20"
                    height="20"
                  />
                </button>
              </span>
            </div>
          </div>
        </div>
        <div className="product-overview print-overview">
          <div className="product-detail-page__image-gallery print-overview-left">
            <div className="image-reel row">
              <div className="col-12">
                <div className="pdp-image-reel__image-stack-view">
                  <ul className="pl-0 list-inline pdp-image-reel__image-stack-list">
                    <li className="pdp-image-reel__image-list">
                      <div className="pdp-image-reel__image-display">
                        {initImage ? (
                          <img
                            role="button"
                            src={initImage}
                            alt={initImageAlt}
                            tabIndex="0"
                            className="print"
                          />
                        ) : (
                          <p className="shimmer-loading__para shimmer height-400" />
                        )}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="product-detail-page__content-section print-overview-right">
            <div className="row no-gutters product-detail-page__main">
              <div className="col-12">
                <div className="product-detail-page__price-value">
                  <span>
                    <p className="shimmer-loading__para shimmer width-170"></p>
                  </span>
                </div>
                <h1 className="product-detail-page__title-desc">
                  <span className="product-detail-page__title">
                    {pdpBrnadName}
                  </span>
                  <p className="product-detail-page__description">
                    {pdpShotDesc}
                  </p>
                </h1>
                <span className="product-detail-page__sku-id">
                  {" "}
                  {productID}
                </span>
              </div>
            </div>
            <div className="row no-gutters product-detail-page__price-main">
              {
                <div className="col-12 product-detail-page__price">
                  {masterSku === skuId &&
                  !pdpJson?.disableEcommerce &&
                  !isProductPriceSpiderIncluded ? (
                    <div
                      className="product-detail-page__price-value"
                      tabIndex="0"
                    >
                      <span>
                        <NumericFormat
                          value={
                            process.env.NEXT_PUBLIC_ENABLE_ANY_PERSONA ===
                            "true"
                              ? anyFinalPrice
                              : gstFinalPrice
                          }
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={CONSTANTS.CURRENCY_SIGN}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                      </span>
                    </div>
                  ) : (
                    <span>
                      <p className="shimmer-loading__para shimmer width-170"></p>
                    </span>
                  )}
                </div>
              }
              {masterSku !== skuId ? (
                <div className="col-12 product-detail-page__discount">
                  <span>
                    <p className="shimmer-loading__para shimmer"></p>
                  </span>
                </div>
              ) : null}
              <div className="product-detail-page__list-price--associate">
                {masterSku === skuId && !isProductPriceSpiderIncluded ? (
                  <div className="product-detail-page__list-view">
                    <div className="product-detail-page__list-value">
                      <NumericFormat
                        value={anyFinalPrice}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={CONSTANTS.CURRENCY_SIGN}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                    </div>
                    <div className="product-detail-page__list-text">List</div>
                  </div>
                ) : (
                  <span>
                    <p className="shimmer-loading__para shimmer width-170"></p>
                  </span>
                )}
              </div>
            </div>
            <div className="row no-gutters product-detail-page__finish-sample">
              <div className="col-12 product-detail-page__finish">
                <span className="product-detail-page__finish_value">
                  <p className="shimmer-loading__para shimmer width-170"></p>
                </span>
              </div>
            </div>
            <div className="row no-gutters product-detail-page__color-swatch-main">
              <div className="col-12 product-detail-page__color-swatch">
                <div className="color-swatch">
                  <span className="color-swatch">
                    <p className="shimmer-loading__para shimmer"></p>
                  </span>
                </div>
                <div className="color-swatch">
                  <span className="color-swatch">
                    <p className="shimmer-loading__para shimmer"></p>
                  </span>
                </div>
                <div className="color-swatch">
                  <span className="color-swatch">
                    <p className="shimmer-loading__para shimmer"></p>
                  </span>
                </div>
              </div>
            </div>
            <div className="product-detail-page__narrative-description">
              <p className="shimmer-loading__para shimmer"></p>
              <p className="shimmer-loading__para shimmer"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Loader
